module.exports = __webpack_public_path__ + "static/media/pla_dus_muc_cle.e3a10961.png";